// extracted by mini-css-extract-plugin
export default {"root":"HZzS65PHH7Q4S0WXDSfb","avatar":"iup72akWG9oOAz4XDJcI","klass":"mRyl_QG8BC07vBcKzRCl","title":"wDPTjh9ggLNXjg8AXJ_u","placeHolderShimmer":"ZiYo_39kSOLXmFgzLrRA"};